
import { defineComponent } from "vue";

const Sleepwalking = defineComponent({
  name: "Sleepwalking"
});

export default Sleepwalking;
